<template>
  <section id="contacto" class="contact-section">
    <div class="contact-shell">
      <div class="contact-layout">
        <!-- Panel informativo -->
        <aside class="contact-visual" aria-label="Información de asesoría">
          <img
            src="/image/contacto.jpeg"
            alt="Asesoría personalizada en seguros"
            class="contact-image"
          />

          <div class="contact-overlay"></div>

          <div class="contact-visual-content">
            <div class="trust-badge">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 22C17 20 20 16.5 20 11V5L12 2L4 5V11C4 16.5 7 20 12 22Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 12L10.8 14.3L15.8 9.3"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Más de 500 clientes atendidos</span>
            </div>

            <div class="visual-copy">
              <p class="visual-eyebrow">Protección personalizada</p>
              <h2>Encuentra el seguro adecuado para ti.</h2>
              <p>
                Recibe orientación clara para proteger tu salud, patrimonio,
                familia o empresa.
              </p>
            </div>

            <div class="visual-benefits">
              <span>Atención personalizada</span>
              <span>Respuesta en menos de 24 horas</span>
              <span>Asesoría sin costo</span>
            </div>
          </div>
        </aside>

        <!-- Formulario -->
        <div class="contact-card">
          <header class="form-header">
            <p class="form-eyebrow">Asesoría gratuita</p>
            <h1>Cuéntanos qué necesitas proteger</h1>
            <p>
              Completa tus datos y uno de nuestros asesores se pondrá en
              contacto contigo.
            </p>
          </header>

          <form class="contact-form" @submit.prevent="enviarFormulario">
            <div class="form-grid">
              <div class="form-field">
                <label for="nombre">Nombre completo</label>
                <input
                  id="nombre"
                  v-model.trim="form.nombre"
                  type="text"
                  autocomplete="name"
                  placeholder="Escribe tu nombre"
                  required
                />
              </div>

              <div class="form-field">
                <label for="correo">Correo electrónico</label>
                <input
                  id="correo"
                  v-model.trim="form.correo"
                  type="email"
                  autocomplete="email"
                  placeholder="nombre@correo.com"
                  required
                />
              </div>

              <div class="form-field">
                <label for="telefono">Teléfono</label>
                <input
                  id="telefono"
                  v-model.trim="form.telefono"
                  type="tel"
                  inputmode="tel"
                  autocomplete="tel"
                  placeholder="999 000 0000"
                  required
                />
              </div>

              <div class="form-field">
                <label for="tipoSeguro">Tipo de seguro</label>
                <div class="select-wrapper">
                  <select
                    id="tipoSeguro"
                    v-model="form.tipo_seguro"
                    required
                  >
                    <option value="" disabled>Selecciona una opción</option>
                    <option value="Seguro de Gastos Médicos Mayores">
                      Gastos Médicos Mayores
                    </option>
                    <option value="Seguro Educativo">Seguro Educativo</option>
                    <option value="Seguro de Ahorro">Seguro de Ahorro</option>
                    <option value="Seguro para la Pensión">
                      Seguro para la Pensión
                    </option>
                    <option value="Seguros para la Mujer">
                      Seguros para la Mujer
                    </option>
                    <option value="Seguro de Viajero">Seguro de Viajero</option>
                    <option value="Seguro Hombre Clave">Seguro Hombre Clave</option>
                    <option value="Seguro Inter Socios">Seguro Inter Socios</option>
                    <option value="Seguro de Auto">Seguro de Auto</option>
                    <option value="Seguro de Casa">Seguro de Casa</option>
                    <option value="Seguro de Embarcaciones">
                      Seguro de Embarcaciones
                    </option>
                    <option value="Seguro Vida Grupo">Seguro Vida Grupo</option>
                    <option value="Seguro Colectivo de Gastos Médicos">
                      Colectivo de Gastos Médicos
                    </option>
                    <option value="Seguro de Flotillas">Seguro de Flotillas</option>
                    <option value="Seguro de Transporte">
                      Seguro de Transporte
                    </option>
                    <option value="Seguros Empresariales">
                      Seguros Empresariales
                    </option>
                  </select>

                  <svg
                    class="select-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M7 10L12 15L17 10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <fieldset class="contact-preference">
              <legend>¿Cómo prefieres que te contactemos?</legend>

              <div class="preference-options">
                <label
                  v-for="opcion in opcionesContacto"
                  :key="opcion.id"
                  class="preference-option"
                  :class="{ active: form.contacto.includes(opcion.label) }"
                >
                  <input
                    v-model="form.contacto"
                    type="checkbox"
                    :value="opcion.label"
                  />
                  <span>{{ opcion.label }}</span>
                </label>
              </div>
            </fieldset>

            <div class="form-field form-field-full">
              <div class="label-row">
                <label for="mensaje">Mensaje adicional</label>
                <span>Opcional</span>
              </div>
              <textarea
                id="mensaje"
                v-model.trim="form.mensaje"
                rows="4"
                placeholder="Cuéntanos brevemente qué tipo de protección estás buscando."
              ></textarea>
            </div>

            <button type="submit" class="submit-button" :disabled="enviando">
              <span>{{ enviando ? "Enviando solicitud..." : "Solicitar asesoría" }}</span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M5 12H19M13 6L19 12L13 18"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <transition name="message">
              <div
                v-if="mensajeEnviado"
                class="form-message form-message-success"
                role="status"
              >
                <strong>Solicitud enviada.</strong>
                <span>Un asesor se pondrá en contacto contigo muy pronto.</span>
              </div>
            </transition>

            <transition name="message">
              <div
                v-if="errorEnvio"
                class="form-message form-message-error"
                role="alert"
              >
                <strong>No pudimos enviar tu solicitud.</strong>
                <span>Por favor, inténtalo nuevamente.</span>
              </div>
            </transition>

            <p class="privacy-note">
              Al enviar este formulario aceptas ser contactado para recibir
              información relacionada con tu solicitud. Tus datos serán tratados
              de forma confidencial.
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "FormularioSeguro",
  data() {
    return {
      form: {
        nombre: "",
        correo: "",
        telefono: "",
        tipo_seguro: "",
        contacto: [],
        mensaje: "",
      },
      opcionesContacto: [
        { id: "contactoWhatsapp", label: "WhatsApp" },
        { id: "contactoLlamada", label: "Llamada" },
        { id: "contactoCorreo", label: "Correo electrónico" },
      ],
      mensajeEnviado: false,
      errorEnvio: false,
      enviando: false,
    };
  },
  methods: {
    async enviarFormulario() {
      this.enviando = true;
      this.mensajeEnviado = false;
      this.errorEnvio = false;

      try {
        const respuesta = await axios.post(
          "http://localhost:3000/api/prospectos",
          this.form
        );

        if (respuesta.status === 200 || respuesta.status === 201) {
          this.mensajeEnviado = true;
          this.resetFormulario();
        } else {
          this.errorEnvio = true;
        }
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
        this.errorEnvio = true;
      } finally {
        this.enviando = false;
      }
    },
    resetFormulario() {
      this.form = {
        nombre: "",
        correo: "",
        telefono: "",
        tipo_seguro: "",
        contacto: [],
        mensaje: "",
      };
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.contact-section {
  --primary: #233d72;
  --primary-dark: #182c54;
  --primary-soft: #eef3fb;
  --text: #172033;
  --muted: #667085;
  --border: #dfe5ee;
  --surface: #ffffff;

  position: relative;
  padding: clamp(64px, 8vw, 112px) 24px;
  overflow: hidden;
  background:
    radial-gradient(circle at 10% 10%, rgba(35, 61, 114, 0.08), transparent 32%),
    #f5f7fb;
}

.contact-section::after {
  content: "";
  position: absolute;
  right: -180px;
  bottom: -240px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: rgba(35, 61, 114, 0.05);
  pointer-events: none;
}

.contact-shell {
  position: relative;
  z-index: 1;
  width: min(1180px, 100%);
  margin: 0 auto;
}

.contact-layout {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(520px, 1.1fr);
  min-height: 700px;
  overflow: hidden;
  border: 1px solid rgba(35, 61, 114, 0.1);
  border-radius: 24px;
  background: var(--surface);
  box-shadow: 0 24px 70px rgba(25, 39, 69, 0.12);
}

.contact-visual {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  background: var(--primary-dark);
}

.contact-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contact-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(16, 31, 60, 0.12) 0%,
    rgba(16, 31, 60, 0.78) 72%,
    rgba(16, 31, 60, 0.95) 100%
  );
}

.contact-visual-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 36px;
  color: #ffffff;
}

.trust-badge {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 13px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  background: rgba(17, 35, 68, 0.5);
  backdrop-filter: blur(10px);
  font-size: 0.82rem;
  font-weight: 600;
}

.visual-copy {
  margin-top: auto;
  padding-top: 160px;
}

.visual-eyebrow,
.form-eyebrow {
  margin: 0 0 10px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.visual-eyebrow {
  color: rgba(255, 255, 255, 0.72);
}

.visual-copy h2 {
  max-width: 430px;
  margin: 0;
  font-size: clamp(2rem, 3.2vw, 3.2rem);
  line-height: 1.06;
  letter-spacing: -0.045em;
}

.visual-copy > p:last-child {
  max-width: 440px;
  margin: 18px 0 0;
  color: rgba(255, 255, 255, 0.76);
  font-size: 0.98rem;
  line-height: 1.65;
}

.visual-benefits {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 30px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
}

.visual-benefits span {
  position: relative;
  padding-left: 16px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.78rem;
  font-weight: 500;
}

.visual-benefits span::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
  transform: translateY(-50%);
}

.contact-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(38px, 5vw, 64px);
  background: var(--surface);
}

.form-header {
  max-width: 580px;
  margin-bottom: 32px;
}

.form-eyebrow {
  color: var(--primary);
}

.form-header h1 {
  margin: 0;
  color: var(--text);
  font-size: clamp(2rem, 3vw, 2.75rem);
  line-height: 1.12;
  letter-spacing: -0.04em;
}

.form-header > p:last-child {
  max-width: 540px;
  margin: 14px 0 0;
  color: var(--muted);
  font-size: 0.95rem;
  line-height: 1.65;
}

.contact-form {
  width: 100%;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.form-field {
  min-width: 0;
}

.form-field-full {
  margin-top: 24px;
}

.form-field label,
.contact-preference legend {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 0.83rem;
  font-weight: 650;
}

.form-field input,
.form-field select,
.form-field textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #ffffff;
  color: var(--text);
  font-family: inherit;
  font-size: 0.94rem;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.form-field input,
.form-field select {
  height: 48px;
  padding: 0 14px;
}

.form-field textarea {
  min-height: 108px;
  padding: 13px 14px;
  line-height: 1.55;
  resize: vertical;
}

.form-field input::placeholder,
.form-field textarea::placeholder {
  color: #98a2b3;
}

.form-field input:hover,
.form-field select:hover,
.form-field textarea:hover {
  border-color: #c5cedb;
}

.form-field input:focus,
.form-field select:focus,
.form-field textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(35, 61, 114, 0.1);
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  padding-right: 42px;
  appearance: none;
  cursor: pointer;
}

.select-icon {
  position: absolute;
  top: 50%;
  right: 14px;
  color: #667085;
  pointer-events: none;
  transform: translateY(-50%);
}

.contact-preference {
  min-width: 0;
  margin: 24px 0 0;
  padding: 0;
  border: 0;
}

.preference-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.preference-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 15px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #ffffff;
  color: #475467;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 600;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    color 0.2s ease;
}

.preference-option:hover {
  border-color: #bcc7d7;
}

.preference-option.active {
  border-color: rgba(35, 61, 114, 0.45);
  background: var(--primary-soft);
  color: var(--primary);
}

.preference-option input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.label-row span {
  margin-bottom: 8px;
  color: #98a2b3;
  font-size: 0.76rem;
}

.submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 50px;
  margin-top: 24px;
  padding: 0 22px;
  border: 0;
  border-radius: 10px;
  background: var(--primary);
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.94rem;
  font-weight: 700;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.submit-button:hover:not(:disabled) {
  background: var(--primary-dark);
  box-shadow: 0 10px 24px rgba(35, 61, 114, 0.18);
  transform: translateY(-1px);
}

.submit-button:focus-visible {
  outline: 3px solid rgba(35, 61, 114, 0.2);
  outline-offset: 3px;
}

.submit-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.form-message {
  display: grid;
  gap: 3px;
  margin-top: 16px;
  padding: 13px 14px;
  border-radius: 9px;
  font-size: 0.84rem;
  line-height: 1.45;
}

.form-message-success {
  border: 1px solid #b7e4c7;
  background: #f0faf4;
  color: #216e42;
}

.form-message-error {
  border: 1px solid #f3c2c0;
  background: #fff5f4;
  color: #a33a36;
}

.privacy-note {
  margin: 16px 0 0;
  color: #8a94a5;
  font-size: 0.72rem;
  line-height: 1.55;
  text-align: center;
}

.message-enter-active,
.message-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.message-enter-from,
.message-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (max-width: 1050px) {
  .contact-layout {
    grid-template-columns: 0.8fr 1.2fr;
  }

  .contact-visual-content {
    padding: 30px;
  }

  .contact-card {
    padding: 42px 36px;
  }
}

@media (max-width: 900px) {
  .contact-section {
    padding: 56px 20px;
  }

  .contact-layout {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .contact-visual {
    min-height: 420px;
  }

  .contact-visual-content {
    min-height: 420px;
  }

  .visual-copy {
    padding-top: 90px;
  }

  .contact-card {
    padding: 48px;
  }
}

@media (max-width: 640px) {
  .contact-section {
    padding: 32px 14px;
  }

  .contact-layout {
    border-radius: 18px;
  }

  .contact-visual {
    min-height: 330px;
  }

  .contact-visual-content {
    min-height: 330px;
    padding: 22px;
  }

  .trust-badge {
    font-size: 0.74rem;
  }

  .visual-copy {
    padding-top: 70px;
  }

  .visual-copy h2 {
    font-size: 2rem;
  }

  .visual-copy > p:last-child,
  .visual-benefits {
    display: none;
  }

  .contact-card {
    padding: 34px 22px;
  }

  .form-header {
    margin-bottom: 26px;
  }

  .form-header h1 {
    font-size: 1.8rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .contact-preference,
  .form-field-full,
  .submit-button {
    margin-top: 20px;
  }

  .preference-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .preference-option:last-child {
    grid-column: 1 / -1;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
</style>
